// src/lib/okumanAssets.ts
// 画像パスの決め打ちマッピング＋フォールバック取得

export type PlanLite = { id: number; name: string };

const base = "/assets/okuman_images";

// 1〜5 の固定プランを ID 決め打ちで対応
const idToImages: Record<number, string[]> = {
  1: [`${base}/1PLAN_result.webp`, `${base}/plan1.webp`],
  2: [`${base}/2PLAN_result.webp`, `${base}/plan2.webp`],
  3: [`${base}/3PLAN_result.webp`, `${base}/plan3.webp`],
  4: [`${base}/4PLAN_result.webp`, `${base}/plan4.webp`],
  5: [`${base}/8PLAN_result.webp`, `${base}/plan5.webp`], // 8PLAN_xxx も置かれていたので候補に
};

// 名前から拾える場合の保険（日本語名 → ファイル）
const nameToImages: Record<string, string[]> = {
  "ボート億マンライト": [`${base}/1PLAN_result.webp`, `${base}/plan1.webp`],
  "ブーストギア":       [`${base}/2PLAN_result.webp`, `${base}/plan2.webp`],
  "ゴールドラッシュ":   [`${base}/3PLAN_result.webp`, `${base}/plan3.webp`],
  "プラチナロック":     [`${base}/4PLAN_result.webp`, `${base}/plan4.webp`],
  "タドミネーター":     [`${base}/8PLAN_result.webp`, `${base}/plan5.webp`],
};

export function getImageCandidates(p: PlanLite): string[] {
  const byId = idToImages[p.id] ?? [];
  const byName = nameToImages[p.name] ?? [];
  // 重複除去して返す
  const uniq = Array.from(new Set([...byId, ...byName]));
  // 念のため最後に「プレースホルダ」を入れておく（404ループ防止）
  return uniq.length > 0 ? uniq : [`${base}/menu-01_result.webp`];
}

// 「購入画面へ」ボタン画像（赤ボタン）
export function buyButtonSrc() {
  return `${base}/red_button_buy_small.webp`;
}

// 背景（LP と同じ画像名のまま使う前提）
export function lpBackgroundSrc() {
  return `${base}/boatOKUman_LP_LP-29_haikei.webp`;
}
